import { Sparkles } from "lucide-react";
import { SummaryBlock } from "../sections/SummaryBlock";
import { SectionRenderer } from "../sections/SectionRenderer";
import { ActionBar } from "./ActionBar";
import { AttachmentPreview } from "./AttachmentPreview";
import { ActivityLog } from "./ActivityLog";

export function MessageBubble({ message, onSendMessage }) {
  const isUser = message.role === "user";

  if (isUser) {
    return (
      <div data-testid={`message-user-${message.id}`} className="flex flex-col items-end gap-1.5">
        {message.attachments?.length > 0 && (
          <div className="flex flex-wrap gap-2 justify-end max-w-[80%]">
            {message.attachments.map((att) => (
              <AttachmentPreview key={att.id} attachment={att} />
            ))}
          </div>
        )}
        {message.content && (
          <div className="max-w-[80%] rounded-2xl bg-emerald-600 text-white px-4 py-2.5 text-sm whitespace-pre-wrap">
            {message.content}
          </div>
        )}
      </div>
    );
  }

  const content = message.content && typeof message.content === "object" ? message.content : {};

  // La respuesta fluye sobre el fondo, sin caja, con un ícono pequeño del Orquestador a la izquierda (como un documento).
  return (
    <div data-testid={`message-assistant-${message.id}`} className="flex w-full max-w-[780px] gap-3 py-2 font-['Geist',ui-sans-serif,system-ui,sans-serif]">
      <div aria-hidden="true" data-testid="message-avatar" className="hidden sm:flex shrink-0 mt-1 h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 text-white">
        <Sparkles className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1 max-w-[720px] px-1">
        {message.activity && <ActivityLog activity={message.activity} />}
        {content.summary && <SummaryBlock text={content.summary} />}
        {(content.sections || []).map((section, i) => (
          <SectionRenderer key={i} section={section} index={i} onSendMessage={onSendMessage} />
        ))}
        {content.actions?.length > 0 && <ActionBar actions={content.actions} onSendMessage={onSendMessage} />}
      </div>
    </div>
  );
}
